/**
 * 이 브라우저에 저장된 로그인을 가리키는 localStorage 키 이름 — import 없는 리프 모듈이다.
 * 문서 머리 부트 스크립트(`_document`)가 awsconfig(최상위 await)를 끌어오지 않고도 세션 주입·점유 대기와 같은 이름을 쓰도록
 * 여기에 둔다.
 */

/** Amplify v6 Cognito 세션 키 접두어 — 실제 키는 `<접두어>.<clientId>.…` 다 */
export const COGNITO_STORAGE_KEY_PREFIX = "CognitoIdentityServiceProvider";

/** 마지막 로그인 사용자 이름 필드 — `<접두어>.<clientId>.LastAuthUser` 가 있으면 저장된 로그인이 있다 */
export const COGNITO_LAST_AUTH_USER_FIELD = "LastAuthUser";

/** 점유 대기 표식 키(exclusive-login) — 표식이 있는 동안의 로그인은 아직 확정되지 않았다 */
export const LOGIN_CLAIM_PENDING_KEY = "exclusiveLogin.claimPending";
